import React from 'react';
import { Settings, Bot, GitPullRequest } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RepositorySidebarProps {
  onSelect: (key: string) => void;
  selectedKey: string;
}

const RepositorySidebar: React.FC<RepositorySidebarProps> = ({ onSelect, selectedKey }) => {
  const menuItems = [
    { key: 'pull_requests', label: 'PULL REQUESTS', icon: <GitPullRequest className="h-4 w-4" /> },
    { key: 'instructions', label: 'CUSTOM RULES', icon: <Bot className="h-4 w-4" /> },
    { key: 'settings', label: 'SETTINGS', icon: <Settings className="h-4 w-4" /> },
  ];

  return (
    <div className="w-full bg-neutral-50 dark:bg-neutral-900/10 border-b border-neutral-950 dark:border-neutral-100 overflow-x-auto">
      <nav className="flex min-w-max">
        {menuItems.map(item => (
          <button
            key={item.key}
            onClick={() => onSelect(item.key)}
            className={cn(
                "flex items-center px-6 py-4 text-xs font-mono font-bold tracking-wider border-r border-neutral-950 dark:border-neutral-100 transition-colors uppercase whitespace-nowrap",
                selectedKey === item.key
                    ? "bg-neutral-950 text-neutral-50 dark:bg-neutral-100 dark:text-neutral-950"
                    : "hover:bg-neutral-100 dark:hover:bg-neutral-900 text-muted-foreground hover:text-foreground"
            )}
          >
            {React.cloneElement(item.icon, {
                className: cn("h-4 w-4 mr-2", selectedKey === item.key ? "text-neutral-50 dark:text-neutral-950" : "text-muted-foreground group-hover:text-foreground")
            })}
            {item.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default RepositorySidebar;
